<p>simple-page works!</p>
